import React from "react";
import Row from "react-bootstrap/esm/Row";
import BatBlue from "../../img/bat-blue.png";
import trophy from "../../img/trophy.png";
import telecase from "../../img/telecast.png";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/esm/Col";
import obj from "../../Utils/helpers";
import { useTranslation } from "react-i18next";
import { isEmpty, upperCase } from "lodash";
import BacLayNew from "../MatchDetail/BacLayNew";
const ListSection = ({ data, heading, allOdds, type, score, spark }) => {
  const navigate = useNavigate();
  return (
    <div className="leagueBox mb-4">
      <div className="title">
        <Row>
          <Col md={6}>
            <span className="live">{upperCase(type)}</span>
            <img src={BatBlue} style={{ maxWidth: "20px" }} /> {heading}
          </Col>
          <Col md={6} className="text-dark text-center">
            <Row>
              <Col className="text-center text-white" md={4}>
                1
              </Col>
              <Col className="text-center text-white" md={4}>
                2
              </Col>
              <Col className="text-center text-white" md={4}>
                3
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      {data?.map((item) => {
        let Odds =
          allOdds?.length > 0
            ? allOdds?.find((res) => {
                return res?.mi == item?.marketId;
              })
            : {};
        let scoreUpdated =
          score?.length > 0
            ? score?.find((res) => {
                return res?.eventId == item?.eventId;
              })?.score || ""
            : item?.outcome && item?.outcome != undefined
            ? item?.outcome
            : "";
        if (item?.eventName !== "Indian Premier League") {
          return (
            <div
              onClick={() =>
                navigate(`/match/${item?.eventId}/${item?.marketId}`)
              }
              className="laegueRow pointer-event"
              style={{
                borderBottom: "1px solid rgb(221, 221, 221)",
                cursor: "pointer",padding:"5px 2px"
              }}
            >
              <Row>
                <Col md={6}>
                  <div
                    className="d-flex flex-column align-items-start"
                    style={{ padding: "4px 7px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        justifyContent: "space-between",
                        width: "100%",
                        marginBottom: "0px",
                        color: "black",
                      }}
                    >
                      <span>{item?.eventName}</span>
                      <div
                        style={{
                          color: "rgb(255, 184, 12)",
                          marginLeft: "10px",
                          fontWeight: "600",
                        }}
                      >
                        {scoreUpdated}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span style={{ color: "#959595", fontSize: "10px" }}>
                        {obj.msgDateFormatNew(item?.eventDateTime)}{" "}
                        {obj.msgDateFormatTime(item?.eventDateTime)} |{" "}
                        {item?.seriesName}
                      </span>
                      <div className="d-flex align-items-center">
                        <>
                          {(item?.hasFancy || item?.hasBookmaker) && (
                            <>
                              <img
                                src="../assets/images/casino-icon/f.png"
                                alt=""
                                className="list-icon"
                              />
                              <img
                                src="../assets/images/casino-icon/b.png"
                                alt=""
                                className="list-icon"
                              />
                            </>
                          )}

                          {item?.hasSportBook && (
                            <img
                              src="../assets/images/casino-icon/s.png"
                              alt=""
                              className="list-icon"
                            />
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </Col>

                {item?.runners?.length > 0 && !isEmpty(Odds) && (
                  <Col xs={6} className="text-dark text-center">
                    <Row className="mx-0">
                      {(item?.runners?.length == 2
                        ? [
                            item?.runners[0],
                            {
                              SelectionId: "",
                              RunnerName: "",
                            },
                            item?.runners[1],
                          ]
                        : item?.runners
                      )?.map((res) => {
                        let odds_lay = Odds?.rt?.filter(
                          (todd) => !todd?.ib && todd?.ri == res?.SelectionId
                        );
                        let odds_back = Odds?.rt?.filter(
                          (todd) => todd?.ib && todd?.ri == res?.SelectionId
                        );
                        return (
                          <Col  className="text-center px-0" xs={4}>
                            <div className="d-flex" style={{gap:"2px"}}>
                              <div
                                style={{ padding: "4px 0" }}
                                className={`bluBoxs ${spark && "spark-back"}`}
                              >
                                {odds_back[0]?.rt || "-"}
                                <span>{odds_back[0]?.bv || "-"}</span>
                              </div>
                              <div
                                style={{ padding: "4px 0" ,marginRight:"2px"}}
                                className={`redBoxs  ${spark && "spark-lay"}`}
                              >
                                {odds_lay[0]?.rt || "-"}
                                <span>{odds_lay[0]?.bv || "-"}</span>
                              </div>
                            </div>
                          </Col>
                        );
                      })}

                      {/* <Col className="text-center px-0" xs={4}>
                      {odds_back?.length >= 2 ? (
                        <div className="d-flex ">
                          <div className={`bluBoxs ${spark && "spark-back"}`}>
                            {odds_back[1]?.rt}
                          </div>
                          <div className={`redBoxs  ${spark && "spark-lay"}`}>
                            {odds_lay[1]?.rt}
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <div className="bluBoxs">-</div>
                          <div className="redBoxs">-</div>
                        </div>
                      )}
                    </Col> */}
                    </Row>{" "}
                  </Col>
                )}
                {/* <Col md={5} className="text-dark text-center">
                <Row className="mx-0">
                  <Col className="text-center px-0" md={4}>
                    {odds_back?.length >= 2 ? (
                      <div className="d-flex">
                      <div className={`bluBoxs ${spark && "spark-back"}`}>
                          {odds_back[1]?.rt}
                          <span>{odds_back[1]?.bv}</span>
                        </div>
                        <div className={`redBoxs  ${spark && "spark-lay"}`}>
                          {odds_lay[1]?.rt}
                          <span>{odds_lay[1]?.bv}</span>
                        </div>
                      </div>
                    ) : (
                      emptyOdds()
                    )}
                  </Col>
                  <Col className="text-center px-0" md={4}>
                    {odds_back?.length >= 1 ? (
                      <div className="d-flex">
                          <div className={`bluBoxs ${spark && "spark-back"}`}>
                          {odds_back[0]?.rt}
                          <span>{odds_back[0]?.bv}</span>
                        </div>
                        <div className={`redBoxs  ${spark && "spark-lay"}`}>
                          {odds_lay[0]?.rt}
                          <span>{odds_lay[0]?.bv}</span>
                        </div>
                      </div>
                    ) : (
                      emptyOdds()
                    )}
                  </Col>
                  <Col className="text-center px-0" md={4}>
                    {" "}
                    {odds_back?.length >= 3 ? (
                      <div className="d-flex">
                          <div className={`bluBoxs ${spark && "spark-back"}`}>
                          {odds_lay[2]?.rt}
                          <span>{odds_lay[2]?.bv}</span>
                        </div>
                        <div className={`redBoxs  ${spark && "spark-lay"}`}>
                          {odds_lay[2]?.rt}
                          <span>{odds_lay[2]?.bv}</span>
                        </div>
                      </div>
                    ) : (
                      emptyOdds()
                    )}
                  </Col>
                </Row>
              </Col> */}
              </Row>
            </div>
          );
        }
      })}
    </div>
  );
};

export default ListSection;
